import { errHandler } from "../helper/helper";
let generatedReportWindow = null;

// Your code here...

export const generateBlob = (data) => {
    try {
        const uint8Array = new Uint8Array(data);
        const isPDF = uint8Array[0] === 0x25 && uint8Array[1] === 0x50 && uint8Array[2] === 0x44 && uint8Array[3] === 0x46;

        const isExcel = isExcelFile(uint8Array);
        if (isPDF) {
            const pdfBlob = new Blob([data], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            if (generatedReportWindow && !generatedReportWindow.closed) {
                generatedReportWindow.location.href = pdfUrl;
            } else {
                generatedReportWindow = window.open(pdfUrl, "_blank");
            }
        } else if (isExcel) {
            const currentDate = new Date();
            // Get date in YYYY-MM-DD format
            const formattedDate = currentDate.toISOString().slice(0, 10);

            // Get time in HH-MM-SS format
            const formattedTime = currentDate.toLocaleTimeString('en-US', { hour12: false }).replace(/:/g, '-');
            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const fileName = 'samurthi-ebank-report-'+formattedDate+formattedTime+'.xlsx';
            console.log(fileName)
            require('file-saver').saveAs(blob, fileName);
        }

        else {
            // Create a TextDecoder instance with the desired encoding (e.g., 'utf-8')
            const decoder = new TextDecoder('utf-8');

            // Decode the ArrayBuffer into a string
            const decodedString = decoder.decode(data);

            // Parse the decoded string into a JavaScript object (assuming it's a JSON object)
            let jsonObject = {}
            try {
                jsonObject = JSON.parse(decodedString);
            } catch (error) {
                console.error("Error parsing JSON:", error);
            }

            // Handle the case when 'data' is not a PDF
            errHandler(jsonObject);
        }
    } catch (error) {
        // Handle any errors that may occur during blob creation or window opening
        errHandler("An error occurred while processing the PDF data.");
        console.error(error); // Log the error for debugging
    }
};

function isExcelFile(bytes) {
    // Check if the first few bytes match the ZIP file header signature
    const zipSignature = [80, 75, 3, 4]; // [PK, 3, 4]

    for (let i = 0; i < zipSignature.length; i++) {
        if (bytes[i] !== zipSignature[i]) {
            return false;
        }
    }

    return true;
}
